const API_ROOT = '/material-presets';

const getMaterialsByPresetId = async (http, id) => {
  const { items } = await http.get(`${API_ROOT}/${id}/materials`);

  return items;
};

const MaterialPresetsApi = (http) => ({
  getMaterialsByPresetId: (id) => getMaterialsByPresetId(http, id),
});

export default MaterialPresetsApi;
